import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./ui/popover";
import { Button } from "./ui/Button";
import { FaFacebook } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaXTwitter } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";
import { MdContentCopy } from "react-icons/md";
import { FaFacebookMessenger } from "react-icons/fa";
import { ShareIcon } from '@heroicons/react/24/solid';


const shareOptions = (url: string, title: string) => [
  {
    label: "Copy Link",
    icon: MdContentCopy,
    onClick: async () => {
      await navigator.clipboard.writeText(url);
      alert("Link copied to clipboard");
    },
  },
  {
    label: "Email",
    icon: MdEmail,
    url: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`,
  },
  {
    label: "Facebook",
    icon: FaFacebook,
    url: `https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
  },
  {
    label: "X (Twitter)",
    icon: FaXTwitter,
    url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
  },
  {
    label: "WhatsApp",
    icon: FaWhatsapp,
    url: `https://wa.me/?text=${encodeURIComponent(title + '\n\n' + url)}`,
  },
  {
    label: "Messenger",
    icon: FaFacebookMessenger,
    url: `fb-messenger://share/?link=${encodeURIComponent(url)}`,
  },
];

type Props = {
  url: string;
  title: string;
};

export function SharePopover({ url, title }: Props) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <span className="flex items-center gap-1 hover:bg-gray-100 p-2 text-sm cursor-pointer rounded-lg">
          <ShareIcon className="size-4" />
          <span className="underline">Share</span>
        </span>
      </PopoverTrigger>

      <PopoverContent
        side="bottom"
        align="center"
        sideOffset={8}
        onOpenAutoFocus={(e: Event) => e.preventDefault()}
        onCloseAutoFocus={(e: Event) => e.preventDefault()}
        tabIndex={-1}
        className="w-[320px] sm:w-[400px] bg-white border border-gray-200 shadow-xl rounded-2xl p-6 space-y-4"
      >
        <h2 className="text-lg font-semibold text-gray-900">Share this place</h2>
        <div className="grid grid-cols-2 gap-3">
          {shareOptions(url, title).map(({ label, icon: Icon, url, onClick }) => (
            <Button
              key={label}
              variant="ghost"
              className="flex justify-start items-center gap-2 text-sm text-gray-700 hover:bg-gray-100 p-2 rounded-md transition-colors"
              onClick={onClick}
            >
              {url ? (
                <a href={url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 w-full">
                  <Icon className="text-xl" />
                  <span>{label}</span>
                </a>
              ) : (
                <>
                  <Icon className="text-xl" />
                  <span>{label}</span>
                </>
              )}
            </Button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
